export const LAYOUT = {
    SIDE_PADDING: 24,
    HEADER_HEIGHT: 60,
}